// extracted by mini-css-extract-plugin
module.exports = {"marked_list_wrapper":"_0fce717cdb--marked_list_wrapper--evSTF"};